import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface EnviarCotacaoEmailDialogData {
  nomeFornecedor: string;
  destinatarioPadrao: string;
}

// Confirma o envio da cotação ao fornecedor, com o e-mail (pré-preenchido do
// cadastro do fornecedor) editável antes do disparo.
@Component({
  selector: 'app-enviar-cotacao-email-dialog',
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatTooltipModule],
  templateUrl: './enviar-cotacao-email-dialog.component.html',
  styleUrl: './enviar-cotacao-email-dialog.component.css',
})
export class EnviarCotacaoEmailDialogComponent {
  public destinatario: string;

  constructor(
    public dialogRef: MatDialogRef<EnviarCotacaoEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EnviarCotacaoEmailDialogData
  ) {
    this.destinatario = data.destinatarioPadrao ?? '';
  }

  public isValido(): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((this.destinatario ?? '').trim());
  }

  public confirmar(): void {
    if (this.isValido()) {
      this.dialogRef.close(this.destinatario.trim());
    }
  }

  public fechar(): void {
    this.dialogRef.close();
  }
}
